import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../constants/common'
import { hasTinyMceHtmlVisibleText } from '../../../utils/html'
import {
  NEWSBOARD_POST_MESSAGE_FIELD_NAME,
  NEWSBOARD_POST_TICKER_MESSAGE_MAX_LENGTH,
} from '../Newsboard.constants'

function getNewsboardPostProfileEditTickerMessageValidationSchema() {
  return Yup.object({
    [NEWSBOARD_POST_MESSAGE_FIELD_NAME]: Yup.string()
      .trim()
      .required(() => true)
      .max(NEWSBOARD_POST_TICKER_MESSAGE_MAX_LENGTH, () => true),
  })
}

export function getNewsboardPostProfileEditMessageInitialValues(text) {
  return {
    [NEWSBOARD_POST_MESSAGE_FIELD_NAME]: text || EMPTY_STRING,
  }
}

export function getNewsboardPostProfileEditMessagePayload(values) {
  return {
    [NEWSBOARD_POST_MESSAGE_FIELD_NAME]:
      values[NEWSBOARD_POST_MESSAGE_FIELD_NAME],
  }
}

export function getNewsboardPostProfileEditMessageValidationSchema(ticker) {
  if (ticker) {
    return getNewsboardPostProfileEditTickerMessageValidationSchema()
  }

  return Yup.object({
    [NEWSBOARD_POST_MESSAGE_FIELD_NAME]: Yup.string().test(
      'has-visible-text',
      () => true,
      value => hasTinyMceHtmlVisibleText(value)
    ),
  })
}
